import { MenuItem, Select, OutlinedInput, Skeleton } from "@mui/material"
import { Fragment } from "react"
import { uid } from "uid"

function SelectInputA({ id, options = [], renderValueKey, selectLabel, value, varianttype, loading = false, ...rest }) {
  id = id || uid(6)

  const selectedOption = options.find(option =>
    option.value === value?.value || option.value === value
  ) || value

  return (
    <Fragment>
      {loading ?
        <Skeleton
          sx={{
            width: "100%",
            height: "100%",
            transform: "none",
            maxHeight: "40px",
          }}
        /> :
        <Select
          size="small"
          defaultValue={selectedOption}
          input={<OutlinedInput id={id} />}
          sx={{
            borderRadius: 5,
            overflow: "hidden",
            "fieldset": { border: "none" },
            ".MuiInputBase-input": {
              height: "24px",
              py: "0",
              px: 1,
              fontSize: 13,
              color: "white",
              borderRadius: 5,
              fontFamily: "Poppins",
              textTransform: "capitalize !important",
              bgcolor: selectedOption?.value === "pending" ?
                "warning.main" :
                (selectedOption?.value === "approved" ||
                  selectedOption?.value === true) ?
                  "success.main" :
                  (selectedOption?.value === "rejected" ||
                    selectedOption?.value === false) ?
                    "error.main" :
                    "default",
            }
          }}
          renderValue={(option) => option[renderValueKey] || selectLabel || "Select"}
          {...rest}
        >
          {options?.map((option, i) => (
            <MenuItem
              sx={{
                color: "black",
                fontSize: "14px",
                fontFamily: "Poppins",
                textTransform: "capitalize"
              }}
              key={i}
              value={option}
              disableRipple
            >{option?.text || option?.name}
            </MenuItem>
          ))}
        </Select>
      }
    </Fragment>
  )
}

export default SelectInputA